var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:'yz-button '+_vm.type,on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }